import * as actionTypes from "../actionTypes.js";

const initialState = {
  currenciesList: null,
};

const consumerVirtualCardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENCIES_CON_VCN:
      return { ...state, currenciesList: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default consumerVirtualCardsReducer;